<section class="delete-popup">
    <button type="button" class="close-btn" aria-label="Close" (click)="cancel()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>

    <div class="icon-circle">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
    </div>

    <div class="delete-title">{{ data.heading }}</div>
    <div class="delete-subtext">{{ data.subText }}</div>

    <div class="footer-section">
        <button type="button" class="btn-cancel" (click)="cancel()">{{ data.secondaryButton }}</button>
        <button type="button" class="btn-delete" (click)="deleteoption()">{{ data.primaryButton }}</button>
    </div>
</section>
